import AppLogoMarkFull from '@/components/app-logo-full';
import AppLogoIcon from '@/components/app-logo-icon';
import { LazyImage } from '@/components/ui/lazy-image';
import { Typo } from '@/components/ui/typography';
import { useIsMobile } from '@/hooks/use-mobile';
import { Link } from '@inertiajs/react';
import { type PropsWithChildren } from 'react';

interface AuthLayoutProps {
  name?: string;
  title?: string;
  description?: string;
  bgImage?: string;
}

export default function AuthSimpleLayout({ children, title, description, bgImage }: PropsWithChildren<AuthLayoutProps>) {
  const isMobile = useIsMobile();
  return (
    <div className="bg-background flex min-h-svh items-center justify-center gap-10 p-6 md:p-10">
      {!isMobile && bgImage && (
        <>
          <div className="border-gray size-100 overflow-hidden">
            <LazyImage delayTime={1000} src={bgImage || ''} alt="bg-login" className="size-100 rounded-lg object-cover" />
          </div>
          <div className="h-[400px] border-r border-gray-300"></div>
        </>
      )}

      <div className="w-full max-w-lg">
        <div className="flex flex-col gap-8">
          <div className="flex flex-col items-center gap-4">
            <Link href={route('home')} className="flex flex-col items-center gap-2 font-medium">
              <div className="mb-1 flex h-16 items-center justify-center rounded-md">
                <AppLogoMarkFull className="h-12 fill-current max-w-[70vw] text-[var(--foreground)]" />
              </div>
              <span className="sr-only">{title}</span>
            </Link>

              <Typo className="text-2xl font-medium" variant='h2'>{title}</Typo>
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}
